import { render } from "./AnimatedCounter.vue?vue&type=template&id=d2fd650a"
import script from "./AnimatedCounter.vue?vue&type=script&lang=js"
export * from "./AnimatedCounter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__